export function logoutToPin() {
  // Ključevi koje čuvamo (device settings + etikete + kuhinja)
  const keep = new Set([
    "api_base_url","local_order_seq","auto_sync_sec",
    "local_order_seq","lock_duration_sec",
    "printer_ip","printer_share","print_after_fiscal",
    "fiscal_ip","fiscal_port",
    "fiscal_operator","fiscal_password","fiscal_demo_mode",
    "device_token","device_name","device_uuid",
    "kitchen_max_cols","kitchen_card_width","kitchen_sound_enabled","kitchen_sound_kind","kitchen_sound_volume",
    "label_kitchen_title","label_table","label_take","label_ready",
    "pos.device","pos.theme",'tvq.settings',
    "pos.outlet",
    "barqueue.labels","barqueue.prepared_items",
    "kitchenqueue.labels","kitchenqueue.prepared_items",
    "kitchenqueue.sounds",
    "kitchenqueue.sounds.volume","kitchenqueue.sounds.kind","kitchenqueue.sounds.enabled",
    "kitchenqueue.sounds.last",
    "device.last_sync","device.last_sync_status"
  ]);

  const saved: Record<string,string> = {};
  for (let i=0;i<localStorage.length;i++){
    const k = localStorage.key(i)!;
    if (keep.has(k) || k.startsWith("device.")) {
      const v = localStorage.getItem(k);
      if (v != null) saved[k] = v;
    }
  }
  localStorage.clear();
  Object.entries(saved).forEach(([k,v]) => localStorage.setItem(k,v));
  try { sessionStorage.clear(); } catch {}
  // Reload — aplikacija će vratiti na PIN login
  window.location.href = "/";
}